// @ts-nocheck
/* eslint-disable @typescript-eslint/no-redeclare */

import { makeApi, Zodios } from '@zodios/core'
import { z } from 'zod'
import { useStore } from '../../store/app'
import { pluginToken } from '@zodios/plugins'
import { ZodiosHooks } from '@zodios/react'
import { useMsalInstance, acquireTokenSilent } from '../../store/MsalContextProvider'

const BerichtRequest = z.object({
  datumVan: z.string().datetime({ offset: true }).nullable(),
  datumTm: z.string().datetime({ offset: true }).nullable(),
  contractorGln: z.string().nullable(),
})
const BerichtBezorgingDto = z.object({
  key: z.string().nullable(),
  berichtId: z.number().int(),
  bezorgingId: z.number().int().nullable(),
  ontvangen: z.string().datetime({ offset: true }),
  opdracht: z.string().nullable(),
  opdrachtStatus: z.string().nullable(),
  soort: z.string().nullable(),
  werkwijze: z.string().nullable(),
  statusId: z.number().int(),
  status: z.string().nullable(),
  vanId: z.number().int().nullable(),
  van: z.string().nullable(),
  naarId: z.number().int().nullable(),
  naar: z.string().nullable(),
  toelichting: z.string().nullable(),
  msgId: z.string().nullable(),
  ontvangenBerichtId: z.string().nullable(),
  ontvangenBerichtResponseId: z.string().nullable(),
  bezorgdBerichtId: z.string().nullable(),
  bezorgdBerichtResponseId: z.string().nullable(),
  laatsteMutatie: z.string().datetime({ offset: true }).nullable(),
  bezorgingHttpStatusCode: z.string().nullable(),
  factuurNummer: z.string().nullable(),
  errorResponse: z.string().nullable(),
  aannemerNaam: z.string().nullable(),
})
const id = z.string().uuid()
const StatistiekDatumSelectieRequest = z.object({
  datumVan: z.string().datetime({ offset: true }).nullable(),
  datumTm: z.string().datetime({ offset: true }).nullable(),
})
const DashboardStatistiekPerStatus = z.object({
  alleBerichten: z.number().int(),
  onbestelbaar: z.number().int(),
  inBehandeling: z.number().int(),
  nietBezorgd: z.number().int(),
  bezorgd: z.number().int(),
  handmatigAfgehandeld: z.number().int(),
  aantalNietBezorgdFactuur: z.number().int(),
  aantalNietBezorgdOpdracht: z.number().int(),
  aantalNietBezorgdStatus: z.number().int(),
})
const DashboardStatistiekPerType = z.object({
  aantalOpdrachtBerichten: z.number().int(),
  aantalStatusBerichten: z.number().int(),
  aantalFactuurBerichten: z.number().int(),
})
const PortalSettings = z.object({
  apiScopes: z.array(z.string()).nullable(),
  clientId: z.string().nullable(),
  redirectUri: z.string().nullable(),
  postLogoutRedirectUri: z.string().nullable(),
})
const AannemerInfoDto = z.object({ naam: z.string().nullable(), glnCode: z.string().nullable() })

export const zodEndpoints = makeApi([
  {
    method: 'post',
    path: '/api/abp/Bericht',
    alias: 'postApiabpBericht',
    requestFormat: 'json',
    parameters: [
      {
        name: 'body',
        type: 'Body',
        schema: BerichtRequest,
      },
    ],
    response: z.array(BerichtBezorgingDto),
  },
  {
    method: 'get',
    path: '/api/abp/Bericht/files/:id',
    alias: 'getApiabpBerichtfilesId',
    requestFormat: 'json',
    parameters: [
      {
        name: 'id',
        type: 'Path',
        schema: id,
      },
    ],
    response: z.void(),
  },
  {
    method: 'post',
    path: '/api/abp/Dashboard/statistieken/status',
    alias: 'postApiabpDashboardstatistiekenstatus',
    requestFormat: 'json',
    parameters: [
      {
        name: 'body',
        type: 'Body',
        schema: StatistiekDatumSelectieRequest,
      },
    ],
    response: DashboardStatistiekPerStatus,
  },
  {
    method: 'post',
    path: '/api/abp/Dashboard/statistieken/type',
    alias: 'postApiabpDashboardstatistiekentype',
    requestFormat: 'json',
    parameters: [
      {
        name: 'body',
        type: 'Body',
        schema: StatistiekDatumSelectieRequest,
      },
    ],
    response: DashboardStatistiekPerType,
  },
  {
    method: 'get',
    path: '/api/abp/FrontendConfig/portal',
    alias: 'getApiabpFrontendConfigportal',
    requestFormat: 'json',
    response: PortalSettings,
  },
  {
    method: 'get',
    path: '/api/abp/Instellingen/aannemer-info',
    alias: 'getApiabpInstellingenaannemerInfo',
    requestFormat: 'json',
    response: AannemerInfoDto,
  },
  {
    method: 'get',
    path: '/api/abp/Me/aannemer',
    alias: 'getApiabpMeaannemer',
    requestFormat: 'json',
    response: z.void(),
  },
])

export {
  BerichtRequest,
  BerichtBezorgingDto,
  id,
  StatistiekDatumSelectieRequest,
  DashboardStatistiekPerStatus,
  DashboardStatistiekPerType,
  PortalSettings,
  AannemerInfoDto,
}

export const useZod = () => {
  const settings = useStore.getState().configuration
  const zodios = new Zodios(settings.apiEndpoint, zodEndpoints)
  const msalContext = useMsalInstance()
  zodios.use(
    pluginToken({
      getToken: async () => {
        const response = await acquireTokenSilent(msalContext.instance, settings.apiScopes)
        return response.accessToken
      },
    })
  )
  const zodiosHooks = new ZodiosHooks('localApi', zodios)
  return { zodios, zodiosHooks }
}
